<template>
  <div id="follow-up-records">
    <div class="list" v-if="list.length > 0">
      <div class="line" v-for="(item, index) in list" :key="index">
        <div class="left-div">
          <div class="icon">
            <img
              :src="item.icon"
              alt=""
              :style="{ width: '30px', height: '30px' }"
            />
          </div>
          <div class="mark-content">
            <span
              class="unmark"
              v-if="item.clientDemandStatus == 0 && item.model == 'client'"
              @click="handleClick(item, 1)"
              >未标</span
            >
            <span
              class="marked"
              v-if="item.clientDemandStatus == 1 && item.model == 'client'"
              @click="handleClick(item, 0)"
              >已标</span
            >
          </div>
        </div>

        <div class="content">
          <div class="name">
            {{ item.name }}
          </div>
          <div class="text">
            {{ item.content }}
          </div>
          <div class="stage" v-if="item.stage">
            <span>跟进阶段:</span>{{ item.stage }}
          </div>
          <div
            class="time"
            v-if="item.model == 'archives' || item.model == 'tax'"
          >
            <span>操作时间:</span>{{ item.time }}
          </div>
          <div
            class="time"
            v-if="
              item.model !== 'archives' && item.model !== 'tax' && item.time
            "
          >
            <span>下次联系时间: </span>{{ item.time }}
          </div>
        </div>
        <div class="time">
          {{ item.operTime }}
          <el-button
            v-if="item.telBill && item.telBill.recordFileUrl"
            type="primary"
            size="mini"
            @click="voiceToText(item)"
            >电话录音</el-button
          >
        </div>
      </div>
    </div>
    <div class="list list-empty" v-else>
      <span class="empty">暂无跟进记录</span>
    </div>
    <div class="input_data" v-if="hasContent">
      <div class="line">
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入跟进内容"
          v-model="activeContent"
        >
        </el-input>
      </div>
      <div class="line" v-if="hasPhase">
        <div class="title">跟进阶段:</div>
        <div class="value">
          <el-select
            v-model="activePhase"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in phaseList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="line">
        <div class="title">下次联系时间:</div>
        <div class="value">
          <el-date-picker
            v-model="activeTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择下次联系时间"
            clearable
          >
          </el-date-picker>
        </div>
      </div>
      <div class="line" v-if="hasTarget">
        <div class="title">领取目标:</div>
        <div class="value">
          <el-radio-group v-model="activeTarget">
            <el-radio
              v-for="(item, index) in targetList"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div class="line" v-if="hasTarget">
        <div class="title">微信待加:</div>
        <div class="value">
          <el-radio-group v-model="activeWeChatFriend">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="buts" v-if="hasContent">
      <el-button
        @click="addFollowRecord"
        v-showFunction="{ active: 'cancel', array: allFunctionButtons }"
        size="small"
        type="primary"
      >
        确定
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    allFunctionButtons: {
      type: Array,
      default: function () {
        return [];
      },
    },
    hasContent: {
      type: Boolean,
      defalut: function () {
        return true;
      },
    },
    content: {
      // 本次跟进内容
      type: String,
      default: function () {
        return "";
      },
    },
    time: {
      // 下次跟进时间
      type: String,
      default: function () {
        return;
      },
    },
    list: {
      // 跟进列表
      type: Array,
      defailt: function () {
        return [];
      },
    },
    hasTarget: {
      // 是否有目标(在资源界面跟进时使用)
      type: Boolean,
      default: function () {
        return false;
      },
    },
    target: {
      // 目标 默认商机池  选项值: 我的商机
      type: String,
      default: function () {
        return "";
      },
    },
    hasPhase: {
      // 是否有跟进阶段 在商机模块使用
      type: Boolean,
      default: function () {
        return false;
      },
    },
    phase: {
      // 跟进阶段
      type: String,
      default: function () {
        return "";
      },
    },
    addWeChatFriend: {
      // 跟进阶段
      type: Boolean,
      default: function () {
        return false;
      },
    },
    clientId: {
      // 客户id
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      isStarOn: false,
      phaseList: [], // 跟进阶段列表
      baseInfo: {},
      targetList: [
        {
          label: "号码错误",
          value: "号码错误",
        },
        {
          label: "同行电话",
          value: "同行电话",
        },
        {
          label: "态度恶劣",
          value: "态度恶劣",
        },
        {
          label: "风险号码",
          value: "风险号码",
        },
        {
          label: "没有意向",
          value: "没有意向",
        },
        {
          label: "我的商机",
          value: "我的商机",
        },
      ],
      activeContent: this.content,
      activeTime: this.time,
      activeTarget: this.target,
      activePhase: this.phase,
      activeWeChatFriend: this.addWeChatFriend,
      currentAudio: null,
    };
  },
  watch: {
    content() {
      this.activeContent = this.content;
    },
    time() {
      this.activeTime = this.time;
    },
    target() {
      this.activeTarget = this.target;
    },
    phase() {
      this.activePhase = this.phase;
    },
    addWeChatFriend() {
      this.activeWeChatFriend = this.addWeChatFriend;
    },
  },
  methods: {
    // 获取跟进记录标签
    getTagList() {
      this.phaseList = [];
      let requestData = {
        type: ["跟进阶段"],
        companyId: this.baseInfo.company.companyId,
      };
      this.$request(
        "post",
        "/getTagList",
        requestData,
        (data) => {
          if (data.length > 0) {
            this.phaseList = data[0].value;
          }
        },
        (err) => {
          this.$message.error(err);
        },
      );
    },
    /**
     * 确定添加跟进记录
     */
    addFollowRecord() {
      let data = {
        content: this.activeContent,
        time: this.activeTime,
        target: this.activeTarget,
        phase: this.activePhase,
        weChatFriend: this.activeWeChatFriend,
      };
      this.$emit("addFollowRecord", JSON.parse(JSON.stringify(data)));
      this.activePhase = "";
      this.activeContent = "";
      this.activeTime = "";
      this.activeTarget = "";
      this.activeWeChatFriend = false;
    },
    handleClick(item, flag) {
      let requestData = {
        clientId: this.clientId, // 客户id
        id: item.id, // 跟踪记录id
        clientDemandStatus: flag, //客户个性化需求状态：1-是 0-否
        createUserId: this.baseInfo.userId, // 登录用户userId
      };
      this.$request(
        "post",
        "/followRecord/modifyClientDemandStatus",
        requestData,
        (data) => {
          this.$message.success("操作成功!");
          item.clientDemandStatus = flag;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 录音转文字
    voiceToText(item) {
      this.$emit("voiceToText", item);
    },
  },
  mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.getTagList();
  },
};
</script>

<style lang="less" scoped>
#follow-up-records {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  > .list {
    width: 100%;
    height: auto;
    max-height: 50vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    > .line {
      width: 100%;
      height: auto;
      display: flex;
      padding: 10px 10px;
      box-sizing: border-box;
      border-bottom: 1px solid #d1d3d8;
      > .left-div {
        display: flex;
        flex-direction: column;
        margin-right: 5px;
        > .icon {
          height: 33px;
          display: flex;
          align-items: flex-start;
          justify-content: center;

          > img {
            width: 50px;
            height: 50px;
            border-radius: 25px;
          }
        }

        .mark-content {
          flex: 1;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-end;
          font-size: 14px;
          color: rgb(49, 49, 49);

          .unmark {
            cursor: pointer;
            font-size: 9px;
            border-radius: 3px;
            padding: 2px;
            margin-right: 5px;
            color: #19be6b;
            border: 1px solid #19be6b;
            background-color: #f0f9eb;
          }

          .marked {
            cursor: pointer;
            font-size: 9px;
            border-radius: 3px;
            padding: 2px;
            margin-right: 5px;
            color: #f9a437;
            border: 1px solid #f9a437;
            background-color: #fcf1e4;
          }
        }
      }
      > .content {
        width: 0;
        flex: 1;
        height: auto;
        display: flex;
        flex-direction: column;
        > .name {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-size: 14px;
        }
        > .text {
          width: 100%;
          height: auto;
          // display: flex;
          align-items: center;
          margin: 10px 0;
          justify-content: flex-start;
          font-size: 14px;
          color: rgb(49, 49, 49);
          text-align: left;
          .icon {
            font-size: 14px;
            margin-left: 2px;
            display: inline-block;
            color: #409eff;
            cursor: pointer;
          }
        }
        > .stage,
        > .time {
          width: 100%;
          height: 28px;
          display: flex;
          align-items: baseline;
          justify-content: flex-start;
          font-size: 14px;
          span {
            margin-right: 5px;
          }
        }
      }
      > .time {
        width: auto;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        font-size: 14px;
        vertical-align: middle;
      }
    }
    .empty {
      font-size: 14px;
      color: #9ba1a7;
    }
    &.list-empty {
      min-height: 200px;
      justify-content: center;
      align-items: center;
    }
  }
  > .input_data {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    padding-top: 5px;
    box-sizing: border-box;
    > .line {
      width: 100%;
      height: auto;
      padding: 5px 10px;
      display: flex;
      box-sizing: border-box;
      > .title {
        width: 20%;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        box-sizing: border-box;
        font-size: 14px;
        margin-right: 5px;
      }
      > .value {
        width: 0;
        flex: 1;
        height: 100%;
        display: flex;
        align-items: flex-start;
      }
    }
  }
  > .buts {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-radio-group {
    display: flex;
    flex-wrap: wrap;
    .el-radio {
      height: 25px;
      margin-top: 3px;
    }
  }
}
</style>
